import { getApiBase } from "@/utils/apiPlatform";
import { CDN_IMG_BASE } from "@/config";
export function resolveCdnUrl(url) {
    if (url == null || url === "")
        return "";
    const u = String(url);
    if (u.startsWith("http://") || u.startsWith("https://"))
        return u;
    if (u.startsWith("/files/"))
        return `${String(getApiBase() || "").replace(/\/$/, "")}${u}`;
    const base = String(CDN_IMG_BASE || "").replace(/\/$/, "");
    return `${base}${u.startsWith("/") ? "" : "/"}${u}`;
}
